// MARK: React
import * as React from "react";
import { observer } from "mobx-react";
import "./style.scss";

// MARK: Icons
import { StarRateOutlined as MStarRateOutlinedIcon } from "@material-ui/icons";

interface IProps {
	text: string;
	grade: number;
	textSize?: number;
	isBold?: boolean;
}

@observer
export default class RatedText extends React.Component<IProps> {
	public render () {
		const { text, grade, textSize, isBold } = this.props;
		return (
			<div className="ratedText">
				<div className="ratedTextContent">
					<p
						style={textSize ? { fontSize: `${textSize}px` } : { fontSize: "16px" }}
					>
					{ isBold ?
						<strong>{text}</strong> :
						text
					}
					</p>
				</div>
				<div className="ratedTextGrade">
					<span>{grade && grade.toFixed(1).toString()}</span>
					<MStarRateOutlinedIcon style={{ fill: "#FCE94F" , fontSize: "25px"}} />
				</div>
			</div>
		);
	}
}
